/* BORROWED. — wires the on-page signup forms to Klaviyo */
(function () {
  var COMPANY_ID = 'RazVW7';
  var LIST_ID = 'VAULvH'; /* "Email List" */
  var REVISION = '2024-10-15';
  var OK = '’re in. Check your inbox.';

  function note(form) {
    return (form.closest('section, div') || document).querySelector('#brwd-signNote')
      || document.getElementById('brwd-signNote');
  }

  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    });
  }

  function bind() {
    var forms = document.querySelectorAll('#brwd-signup');
    Array.prototype.forEach.call(forms, function (f) {
      if (f.getAttribute('data-kl-bound')) return;
      f.setAttribute('data-kl-bound', '1');
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = f.querySelector('input[type="email"]') || f.querySelector('input');
        var n = note(f);
        var email = input && input.value ? input.value.trim() : '';
        if (!email || email.indexOf('@') < 1) {
          if (n) n.textContent = 'Enter a valid email address.';
          return;
        }
        if (n) n.textContent = 'One moment…';
        subscribe(email).then(function (r) {
          if (r.status === 202 || r.ok) {
            if (n) n.textContent = 'You' + OK;
            input.value = '';
          } else {
            if (n) n.textContent = 'That did not go through. Email hello@houseofborrowed.com and we will add you.';
          }
        }).catch(function () {
          if (n) n.textContent = 'That did not go through. Email hello@houseofborrowed.com and we will add you.';
        });
      });
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
